import {defineStore} from 'pinia'
import {nextTick} from "vue"
import axios from "axios"
import {setLocalStorage, getLocalStorage} from "@js/helpers.ts"
import {checkDocument} from "@js/helpers.ts"

export const useSearchStore = defineStore('searchStore', {
    state: () => ({
        query: '',
        show: false,
        resultsLoaded: true,
        history: getLocalStorage('history_search') ? JSON.parse(getLocalStorage('history_search')) : [],
        results: [],
        getSearchTimeout: null,

        imageSearch: {
            previewUrl: null,
            file: null,
            inProgress: false,
            isOpen: false,
            imageSearchInProgress: false,
            results: [],
        },

        imageSearchResult: {
            isOpen: false,
        },

        placeholderOptions: [
            "Дорожная плита",
            "Фундаментный блок",
            "Плита перекрытия",
            "Колодезное кольцо",
            "Труба железобетонная",
            "Гранитный бетон",
            "Брус",
            "Доска строительная",
            "Тротуарная плитка",
            "Щебень"
        ],
        currentPlaceholder: '',
        optionIndex: 0,
        charIndex: 0,
        typing: true,
        placeholderTypingMounted: false,
    }),

    getters: {
        filteredResults: (state) => {
            if (!state.query) return []

            return state.results.filter(r =>
                r.title.toLowerCase().includes(state.query.toLowerCase())
            )
        }
    },

    actions: {
        showImageSearchResult() {
            this.imageSearch.isOpen = false
            this.imageSearchResult.isOpen = true
        },

        hideImageSearchResult() {
            this.imageSearchResult.isOpen = false
        },

        showImageSearch() {
            this.imageSearchResult.isOpen = false
            this.imageSearch.isOpen = true
        },

        hideImageSearch() {
            this.imageSearch.isOpen = false
        },

        resetImageSearchState() {
            this.imageSearch.previewUrl = null
            this.imageSearch.file = null
            this.imageSearch.inProgress = false
            this.imageSearch.imageSearchInProgress = false
            this.imageSearch.results = []
            this.imageSearch.isOpen = false
            this.imageSearchResult.isOpen = false
            this.resultsLoaded = true
        },

        showDropdown() {
            this.show = true
            nextTick()
        },

        clearQuery() {
            this.query = ''
            this.results = []
        },

        repeatHistory(value) {
            this.query = value
            this.initSearch()
        },

        addToHistoryCache() {
            if (this.query === null || this.query === '') return

            const key = 'history_search'
            let history = []

            try {
                const raw = getLocalStorage(key)
                if (raw) {
                    history = JSON.parse(raw)
                }
            } catch (e) {
                history = []
            }

            history = history.filter(item => item !== this.query)
            history.unshift(this.query)
            history = history.slice(0, 3)

            setLocalStorage(key, JSON.stringify(history), 43200)
            this.history = history
        },

        removeFromHistory(value) {
            const key = 'history_search'
            this.history = this.history.filter(item => item !== value)
            setLocalStorage(key, JSON.stringify(this.history), 43200)
        },

        initSearch() {
            this.addToHistoryCache()
        },

        getSearchData() {
            clearTimeout(this.getSearchTimeout)

            this.getSearchTimeout = setTimeout(() => {
                this.results = []

                if (this.query === null || this.query === '') {
                    return
                }

                this.addToHistoryCache()

                if (checkDocument()) {
                    window.scrollTo({top: 0, behavior: 'smooth'})
                }

                this.resultsLoaded = false

                axios.post('/axios/products/text-search', {
                    text: this.query,
                }).then(response => {
                    this.results = response.data
                    this.resultsLoaded = true
                }).catch(() => {
                    this.resultsLoaded = true
                })
            }, 500)
        },

        searchByImage(file) {
            if (!file) {
                console.warn('No file passed to searchByImage')
                return
            }

            this.imageSearch.file = file
            this.imageSearch.imageSearchInProgress = true
            this.imageSearch.results = []
            this.resultsLoaded = false

            const form = new FormData()
            form.append('photo', file)

            axios.post('/axios/search/search-by-image', form, {
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(({data}) => {
                this.imageSearch.results = data
                this.imageSearch.imageSearchInProgress = false
                this.resultsLoaded = true

                this.hideImageSearch()
                this.showImageSearchResult()
            }).catch((error) => {
                console.error('Image search error:', error)
                this.imageSearch.imageSearchInProgress = false
                this.resultsLoaded = true
                this.imageSearch.results = []
            })
        },

        startTypewriterEffect() {
            if (this.placeholderTypingMounted) return

            this.placeholderTypingMounted = true

            const type = () => {
                const currentWord = this.placeholderOptions[this.optionIndex]

                if (this.typing) {
                    if (this.charIndex < currentWord.length) {
                        this.currentPlaceholder += currentWord[this.charIndex]
                        this.charIndex++
                    } else {
                        this.typing = false
                        setTimeout(type, 2000)
                        return
                    }
                } else {
                    if (this.charIndex > 0) {
                        this.currentPlaceholder = this.currentPlaceholder.slice(0, -1)
                        this.charIndex--
                    } else {
                        this.typing = true
                        this.optionIndex = (this.optionIndex + 1) % this.placeholderOptions.length
                    }
                }

                setTimeout(type, this.typing ? 100 : 50)
            }

            type()
        },
    }
})
